"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var i18next = require("i18next");
var ru_js_1 = require("./locales/ru.js");
var defaultLanguage = 'ru';
var i18nInstance = i18next.createInstance();
i18nInstance.init({
    lng: defaultLanguage,
    debug: false,
    resources: ru_js_1.default,
});
exports.default = i18nInstance;
